<template>
    <div class="modal fade" :id="'participantModal' + _uid" role="dialog" aria-labelledby="participantModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="participantModalLabel">{{$t('registers.participants.details')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <participant-details-card v-model="model"
                                           v-if="showDetails"
                                           @cancel="onCancel">
                    </participant-details-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Participant } from '../../models/models';
    import ParticipantDetailsCard from './ParticipantDetailsCard';

    export default {
        components: {
            ParticipantDetailsCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showDetails: false,
                model: new Participant(),
            };
        },
        methods: {
            onClose(e, fromBtn) {
                this.$emit('onClose', { ...this.model });
                this.model = new Participant();
            },
            hide(e) {
                $('#participantModal' + this._uid).modal('hide');
                // $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose(null, true);
            }
        },
        mounted() {
            // add modal close listener
            $('#participantModal' + this._uid).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $('#participantModal' + this._uid).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Participant(this.value);
                    this.showDetails = true;
                    $('#participantModal' + this._uid).modal('show');
                } else {
                    $('#participantModal' + this._uid).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
